import React, { useState } from 'react';
import {
  View,
  Text,
  ScrollView,
  TextInput,
  TouchableOpacity,
  Image,
  useColorScheme,
  FlatList,
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';

const FriendListScreen = ({ navigation }) => {
  const isDarkMode = useColorScheme() === 'dark';
  const [searchText, setSearchText] = useState('');
  const [activeTab, setActiveTab] = useState('all');
  const [friends, setFriends] = useState(mockFriends);
  const [pendingRequests, setPendingRequests] = useState(mockPendingRequests);

  // 处理接受好友请求
  const handleAcceptRequest = (requestId) => {
    const request = pendingRequests.find(req => req.id === requestId);
    if (request) {
      // 添加到好友列表
      setFriends([
        ...friends,
        {
          id: request.id,
          name: request.name,
          avatar: request.avatar,
          healthScore: Math.floor(Math.random() * 30) + 70,
          stats: {
            streak: Math.floor(Math.random() * 20) + 1,
            goals: Math.floor(Math.random() * 5) + 1,
            similarities: Math.floor(Math.random() * 40) + 60,
          },
          tags: ['饮食记录', '健康饮食'],
          groups: ['活跃用户'],
        }
      ]);
      
      // 从待处理请求中移除
      setPendingRequests(pendingRequests.filter(req => req.id !== requestId));
    }
  };

  // 处理拒绝好友请求
  const handleRejectRequest = (requestId) => {
    setPendingRequests(pendingRequests.filter(req => req.id !== requestId));
  };

  // 过滤好友列表
  const getFilteredFriends = () => {
    let filtered = [...friends];
    
    // 应用搜索过滤
    if (searchText) {
      filtered = filtered.filter(friend => 
        friend.name.toLowerCase().includes(searchText.toLowerCase())
      );
    }
    
    // 应用标签过滤
    if (activeTab !== 'all') {
      filtered = filtered.filter(friend => 
        friend.groups.includes(activeTab)
      );
    }
    
    return filtered;
  };

  // 渲染好友项
  const renderFriendItem = ({ item: friend }) => {
    return (
      <TouchableOpacity
        style={{ 
          backgroundColor: isDarkMode ? '#374151' : 'white',
          borderRadius: 16,
          padding: 16,
          marginBottom: 16,
          shadowColor: '#000',
          shadowOffset: { width: 0, height: 1 },
          shadowOpacity: 0.1,
          shadowRadius: 2,
          elevation: 2,
        }}
        onPress={() => navigation.navigate('FriendComparison', { friendId: friend.id })}
      >
        <View style={{ flexDirection: 'row' }}>
          <Image 
            source={{ uri: friend.avatar }} 
            style={{ 
              width: 60, 
              height: 60, 
              borderRadius: 30,
              marginRight: 16, 
            }} 
          />
          <View style={{ flex: 1 }}>
            <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
              <Text style={{ 
                fontSize: 18, 
                fontWeight: 'bold', 
                color: isDarkMode ? 'white' : '#1f2937',
                marginBottom: 4,
              }}>
                {friend.name}
              </Text>
              <View style={{ 
                backgroundColor: getHealthScoreColor(friend.healthScore),
                paddingHorizontal: 8,
                paddingVertical: 4,
                borderRadius: 12,
              }}>
                <Text style={{ 
                  color: 'white', 
                  fontWeight: 'bold',
                  fontSize: 13,
                }}>
                  {friend.healthScore}分
                </Text>
              </View>
            </View>

            <View style={{ 
              flexDirection: 'row', 
              marginTop: 8,
              marginBottom: 12,
            }}>
              <View style={{ marginRight: 16, flexDirection: 'row', alignItems: 'center' }}>
                <Ionicons name="flame" size={14} color="#f59e0b" style={{ marginRight: 4 }} />
                <Text style={{ color: isDarkMode ? '#d1d5db' : '#6b7280', fontSize: 13 }}>
                  连续{friend.stats.streak}天
                </Text>
              </View>
              <View style={{ marginRight: 16, flexDirection: 'row', alignItems: 'center' }}>
                <Ionicons name="trophy" size={14} color="#10b981" style={{ marginRight: 4 }} />
                <Text style={{ color: isDarkMode ? '#d1d5db' : '#6b7280', fontSize: 13 }}>
                  {friend.stats.goals}个目标
                </Text>
              </View>
              <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                <Ionicons name="pie-chart" size={14} color="#8b5cf6" style={{ marginRight: 4 }} />
                <Text style={{ color: isDarkMode ? '#d1d5db' : '#6b7280', fontSize: 13 }}>
                  {friend.stats.similarities}%相似
                </Text>
              </View>
            </View>

            {/* 标签 */}
            <View style={{ flexDirection: 'row', flexWrap: 'wrap' }}>
              {friend.tags.map((tag, index) => (
                <View 
                  key={index} 
                  style={{ 
                    backgroundColor: isDarkMode ? '#4b5563' : '#f3f4f6',
                    paddingHorizontal: 8,
                    paddingVertical: 4,
                    borderRadius: 12,
                    marginRight: 8,
                    marginBottom: 8,
                  }}
                >
                  <Text style={{ 
                    fontSize: 12, 
                    color: isDarkMode ? '#e0e0e0' : '#4b5563',
                  }}>
                    {tag}
                  </Text>
                </View>
              ))}
            </View>
          </View>
        </View>

        <View style={{ 
          flexDirection: 'row', 
          justifyContent: 'space-between',
          marginTop: 12,
          paddingTop: 12,
          borderTopWidth: 1,
          borderTopColor: isDarkMode ? '#4b5563' : '#f3f4f6',
        }}>
          <TouchableOpacity 
            style={{ 
              flexDirection: 'row', 
              alignItems: 'center',
            }}
            onPress={() => navigation.navigate('Messaging', { friendId: friend.id, friendName: friend.name })}
          >
            <Ionicons name="chatbubble-outline" size={18} color="#2563eb" style={{ marginRight: 4 }} />
            <Text style={{ color: '#2563eb', fontWeight: '500' }}>发送消息</Text>
          </TouchableOpacity>
          
          <TouchableOpacity 
            style={{ 
              flexDirection: 'row', 
              alignItems: 'center',
            }}
            onPress={() => navigation.navigate('FriendComparison', { friendId: friend.id })}
          >
            <Ionicons name="analytics-outline" size={18} color="#2563eb" style={{ marginRight: 4 }} />
            <Text style={{ color: '#2563eb', fontWeight: '500' }}>数据对比</Text>
          </TouchableOpacity>
        </View>
      </TouchableOpacity>
    );
  };

  // 渲染好友请求项
  const renderRequestItem = ({ item: request }) => {
    return (
      <View style={{ 
        backgroundColor: isDarkMode ? '#374151' : '#f0f9ff',
        borderRadius: 16,
        padding: 16,
        marginBottom: 16,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: 0.1,
        shadowRadius: 2,
        elevation: 2,
      }}>
        <View style={{ flexDirection: 'row' }}>
          <Image 
            source={{ uri: request.avatar }} 
            style={{ 
              width: 56, 
              height: 56, 
              borderRadius: 28,
              marginRight: 16, 
            }} 
          />
          <View style={{ flex: 1 }}>
            <Text style={{ 
              fontSize: 16, 
              fontWeight: 'bold', 
              color: isDarkMode ? 'white' : '#1f2937',
              marginBottom: 4,
            }}>
              {request.name}
            </Text>
            <Text style={{ color: isDarkMode ? '#d1d5db' : '#6b7280', marginBottom: 8 }}>
              {request.message}
            </Text>

            <View style={{ flexDirection: 'row' }}>
              <TouchableOpacity 
                style={{ 
                  backgroundColor: '#2563eb',
                  paddingHorizontal: 16,
                  paddingVertical: 8,
                  borderRadius: 8,
                  marginRight: 12,
                }}
                onPress={() => handleAcceptRequest(request.id)}
              >
                <Text style={{ color: 'white', fontWeight: 'bold' }}>接受</Text>
              </TouchableOpacity>
              <TouchableOpacity 
                style={{ 
                  backgroundColor: isDarkMode ? '#6b7280' : '#f3f4f6',
                  paddingHorizontal: 16,
                  paddingVertical: 8,
                  borderRadius: 8,
                }}
                onPress={() => handleRejectRequest(request.id)}
              >
                <Text style={{ color: isDarkMode ? 'white' : '#4b5563' }}>拒绝</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </View>
    );
  };

  // 渲染好友分组标签
  const renderGroupTabs = () => {
    const groups = [
      { id: 'all', label: '全部' },
      { id: '活跃用户', label: '活跃用户' },
      { id: '饮食伙伴', label: '饮食伙伴' },
      { id: '运动达人', label: '运动达人' },
    ];

    return (
      <ScrollView 
        horizontal 
        showsHorizontalScrollIndicator={false}
        style={{ marginBottom: 16 }}
      >
        {groups.map((group) => (
          <TouchableOpacity
            key={group.id}
            style={{ 
              paddingHorizontal: 16,
              paddingVertical: 8,
              backgroundColor: activeTab === group.id 
                ? (isDarkMode ? '#4b5563' : '#e0f2fe') 
                : (isDarkMode ? '#374151' : '#f9fafb'),
              borderRadius: 20,
              marginRight: 12,
              borderWidth: activeTab === group.id ? 0 : 1,
              borderColor: isDarkMode ? '#4b5563' : '#e5e7eb',
            }}
            onPress={() => setActiveTab(group.id)}
          >
            <Text style={{ 
              color: activeTab === group.id 
                ? (isDarkMode ? 'white' : '#2563eb')
                : (isDarkMode ? '#d1d5db' : '#6b7280'),
              fontWeight: activeTab === group.id ? 'bold' : 'normal',
              fontSize: 14,
            }}>
              {group.label}
            </Text>
          </TouchableOpacity>
        ))}
      </ScrollView>
    );
  };

  // 获取健康分数对应的颜色
  const getHealthScoreColor = (score) => {
    if (score >= 90) return '#10b981'; // 绿色
    if (score >= 80) return '#2563eb'; // 蓝色
    if (score >= 70) return '#f59e0b'; // 橙色
    return '#ef4444'; // 红色
  };

  const filteredFriends = getFilteredFriends();

  return (
    <View style={{ 
      flex: 1, 
      backgroundColor: isDarkMode ? '#1f2937' : '#f9fafb',
      padding: 16,
    }}>
      {/* 搜索栏 */}
      <View style={{ 
        flexDirection: 'row',
        backgroundColor: isDarkMode ? '#374151' : 'white',
        borderRadius: 12,
        padding: 12,
        marginBottom: 16,
        alignItems: 'center',
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: 0.1,
        shadowRadius: 2,
        elevation: 2,
      }}>
        <Ionicons name="search" size={20} color={isDarkMode ? '#d1d5db' : '#9ca3af'} style={{ marginRight: 8 }} />
        <TextInput
          style={{ 
            flex: 1,
            color: isDarkMode ? 'white' : '#1f2937',
            fontSize: 16,
          }}
          placeholder="搜索好友..."
          placeholderTextColor={isDarkMode ? '#9ca3af' : '#9ca3af'}
          value={searchText}
          onChangeText={setSearchText}
        />
        {searchText !== '' && (
          <TouchableOpacity onPress={() => setSearchText('')}>
            <Ionicons name="close-circle" size={20} color={isDarkMode ? '#d1d5db' : '#9ca3af'} />
          </TouchableOpacity>
        )}
      </View>

      {/* 添加好友按钮 */}
      <TouchableOpacity 
        style={{ 
          flexDirection: 'row',
          alignItems: 'center',
          backgroundColor: isDarkMode ? '#374151' : 'white',
          borderRadius: 12,
          padding: 16,
          marginBottom: 16,
          shadowColor: '#000',
          shadowOffset: { width: 0, height: 1 },
          shadowOpacity: 0.1,
          shadowRadius: 2,
          elevation: 2,
        }}
        onPress={() => navigation.navigate('FriendSearch')}
      >
        <View style={{
          width: 40,
          height: 40,
          borderRadius: 20,
          backgroundColor: '#2563eb',
          justifyContent: 'center',
          alignItems: 'center',
          marginRight: 12,
        }}>
          <Ionicons name="person-add" size={20} color="white" />
        </View>
        <View style={{ flex: 1 }}>
          <Text style={{ 
            fontSize: 16,
            fontWeight: 'bold',
            color: isDarkMode ? 'white' : '#1f2937',
            marginBottom: 2,
          }}>
            添加好友
          </Text>
          <Text style={{ 
            fontSize: 14,
            color: isDarkMode ? '#d1d5db' : '#6b7280',
          }}>
            邀请朋友一起健康生活
          </Text>
        </View>
        <Ionicons name="chevron-forward" size={24} color={isDarkMode ? '#d1d5db' : '#9ca3af'} />
      </TouchableOpacity>

      {/* 好友请求 */}
      {pendingRequests.length > 0 && (
        <>
          <Text style={{
            fontSize: 18,
            fontWeight: 'bold',
            marginBottom: 12,
            color: isDarkMode ? 'white' : '#1f2937',
          }}>
            好友请求 ({pendingRequests.length})
          </Text>
          
          <FlatList
            data={pendingRequests}
            renderItem={renderRequestItem}
            keyExtractor={(item) => item.id}
            scrollEnabled={false}
          />
          
          <View style={{ 
            height: 1, 
            backgroundColor: isDarkMode ? '#4b5563' : '#e5e7eb',
            marginVertical: 16,
          }} />
        </>
      )}

      {/* 好友列表标题 */}
      <View style={{ 
        flexDirection: 'row', 
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 12,
      }}>
        <Text style={{
          fontSize: 18,
          fontWeight: 'bold',
          color: isDarkMode ? 'white' : '#1f2937',
        }}>
          我的好友 ({filteredFriends.length})
        </Text>
        <TouchableOpacity>
          <Text style={{ color: '#2563eb', fontWeight: '500' }}>管理分组</Text>
        </TouchableOpacity>
      </View>

      {/* 分组标签 */}
      {renderGroupTabs()}

      {/* 好友列表 */}
      {filteredFriends.length > 0 ? (
        <FlatList
          data={filteredFriends}
          renderItem={renderFriendItem}
          keyExtractor={(item) => item.id}
          showsVerticalScrollIndicator={false}
        />
      ) : (
        <View style={{ 
          flex: 1, 
          justifyContent: 'center', 
          alignItems: 'center',
          marginTop: 40,
        }}>
          <Ionicons 
            name={searchText ? "search-outline" : "people-outline"} 
            size={60} 
            color={isDarkMode ? '#4b5563' : '#d1d5db'} 
            style={{ marginBottom: 16 }}
          />
          <Text style={{
            fontSize: 18,
            fontWeight: 'bold',
            color: isDarkMode ? 'white' : '#1f2937',
            marginBottom: 8,
          }}>
            {searchText ? '没有找到匹配的好友' : '还没有好友'}
          </Text>
          <Text style={{ 
            color: isDarkMode ? '#d1d5db' : '#6b7280',
            textAlign: 'center',
            paddingHorizontal: 40,
          }}>
            {searchText 
              ? '请尝试使用其他关键词搜索' 
              : '添加好友一起记录饮食、分享健康目标，互相激励！'
            }
          </Text>
        </View>
      )}
    </View>
  );
};

// 模拟数据 - 好友列表
const mockFriends = [
  {
    id: 'f1',
    name: '张健康',
    avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
    healthScore: 92,
    stats: {
      streak: 18,
      goals: 3,
      similarities: 85,
    },
    tags: ['运动达人', '低碳饮食'],
    groups: ['活跃用户', '运动达人'],
  },
  {
    id: 'f2',
    name: '李营养',
    avatar: 'https://randomuser.me/api/portraits/women/44.jpg',
    healthScore: 87,
    stats: {
      streak: 12,
      goals: 2,
      similarities: 72,
    },
    tags: ['均衡饮食', '瑜伽爱好者'],
    groups: ['饮食伙伴'],
  },
  {
    id: 'f3',
    name: '王跑步',
    avatar: 'https://randomuser.me/api/portraits/men/62.jpg',
    healthScore: 89,
    stats: {
      streak: 21,
      goals: 4,
      similarities: 68,
    },
    tags: ['马拉松', '高蛋白饮食'],
    groups: ['活跃用户', '运动达人'],
  },
  {
    id: 'f4',
    name: '赵均衡',
    avatar: 'https://randomuser.me/api/portraits/women/22.jpg',
    healthScore: 78,
    stats: {
      streak: 7,
      goals: 1,
      similarities: 91,
    },
    tags: ['地中海饮食', '饮食记录'],
    groups: ['饮食伙伴'],
  },
];

// 模拟数据 - 待处理的好友请求
const mockPendingRequests = [
  {
    id: 'r1',
    name: '周健身',
    avatar: 'https://randomuser.me/api/portraits/men/29.jpg',
    message: '我们一起健身打卡吧！',
    time: '2天前',
  },
  {
    id: 'r2',
    name: '吴瑜伽',
    avatar: 'https://randomuser.me/api/portraits/women/14.jpg',
    message: '我也在使用这个应用记录饮食～',
    time: '3天前',
  },
];

export default FriendListScreen; 